import { AxiosBookings, orgId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";

export const dispatchApiFactory = {
    $_getDispatches(params) {
        const url = `/dispatch/all/${orgId()}${appendQueryParams(params)}`;
        return AxiosBookings.get(url);
    },
    $_searchDispatches(params) {
        const url = `/dispatch/search/${orgId()}${appendQueryParams(params)}`;
        return AxiosBookings.get(url);
    },

    $_modifyDispatch(dispatchId, payload) {
        const url = `/dispatch/${dispatchId}`;
        return AxiosBookings.patch(url, payload);
    },

    $_cancelDispatch(dispatchId) {
        const url = `/dispatch/delete/${dispatchId}`;
        return AxiosBookings.delete(url);
    },
    $_newCancelDispatch(dispatchId, payload) {
        const url = `/dispatch/cancel/${dispatchId}`;
        return AxiosBookings.patch(url, payload);
    },

    $_getDispatch(id) {
        const url = `/dispatch/one/${id}`;
        return AxiosBookings.get(url);
    },

    $_getDispatchTimeline(dispatchId) {
        const url = `/dispatch/timeline/${dispatchId}`;
        return AxiosBookings.get(url);
    },
    $_acknowledgeDispatchRequest(payload) {
        const url = `/requests/acknowledge`;
        return AxiosBookings.patch(url, payload);
    },
    $_acknowledgeDispatchHandoff(payload) {
        const url = `requests/acknowledge-handoff`;
        return AxiosBookings.patch(url, payload);
    },
    $_getDispatchToplineAnalytics() {
        const url = `/shippings/analytics/${orgId()}`;
        return AxiosBookings.get(url);
    },
    $_getDispatchSummary(payload) {
        const url = `/dispatch//long-haul/summary/${orgId()}`;
        return AxiosBookings.post(url, payload);
    },
     $_getLastMileDispatchSummary(payload) {
        const url = `/dispatch//last-mile/summary/${orgId()}`;
        return AxiosBookings.post(url, payload);
    },
    $_createLongHaulDispatch(payload) {
        const url = `/dispatch/long-haul/create/${orgId()}`;
        return AxiosBookings.post(url, payload);
    },
    $_getDispatchTable(terminalId, params = {}) {
        const url = `/dispatch/dispatchable/${orgId()}/${terminalId}${appendQueryParams(params)}`;
        return AxiosBookings.get(url);
    },
    $_getDispatchableFleetOverview(params) {
        const url = `/dispatch/fleet-overview${appendQueryParams(params)}`;
        return AxiosBookings.get(url);
    },
    $_getDispatchManifest(id, params) {
        const url = `/dispatch/manifest/${id}${appendQueryParams(params)}`;
        return AxiosBookings.get(url);
    },
    $_confirmDispatchShipment(id, payload) {
        const url = `/dispatch/confirm-receipt/${id}`;
        return AxiosBookings.post(url, payload);
    },
    $_updateLongHaulDispatchable(consolidationId, payload) {
        let url = `/consolidation/shipment-status/${consolidationId}`;
        return AxiosBookings.patch(url, payload);
    },

    $_newCreateDispatch(payload) {
        const url = `/dispatch/long-haul/create/${orgId()}`;
        return AxiosBookings.post(url, payload);
    },
    $_getNewDispatchTimeline(id, params) {
        const url = `/dispatch/timeline/${id}${appendQueryParams(params)}`;
        return AxiosBookings.get(url);
    },
    $_getDispatchSummaryLastMile() {
        const url = `/consolidation/vehicles/${orgId()}`;
        return AxiosBookings.get(url);
    },
    $_greateLastMileDispatch(payload) {
        const url = `/dispatch/last-mile/create/${orgId()}`;
        return AxiosBookings.post(url, payload);
    }
};
